module.exports = __webpack_public_path__ + "img/DE03792.4e755067.png";